const FORMAT_STEPS = [
  {
    step: "01",
    icon: "ri-bubble-chart-line",
    title: "标题",
    desc: "一句话概括事件，抓人但别标题党。建议控制在 20 字以内，让读者一眼明白这是哪块瓜。",
  },
  {
    step: "02",
    icon: "ri-quill-pen-line",
    title: "事件概述",
    desc: "开头用两三句话交代瓜料的来龙去脉：发生在哪、涉及谁、核心矛盾是什么，把最关键的悬念放前面。",
  },
  {
    step: "03",
    icon: "ri-list-ordered",
    title: "详细经过",
    desc: "按时间或因果顺序分点展开，条理清晰、叙事完整。可分小标题或段落，避免一整段话让人读得头晕。",
  },
  {
    step: "04",
    icon: "ri-user-star-line",
    title: "关键信息",
    desc: "交代事件涉及的角色（可化名）、时间节点与地点等必要信息，方便读者判断瓜料的真实性与可信度。",
  },
  {
    step: "05",
    icon: "ri-image-add-line",
    title: "佐证配图",
    desc: "如有一手截图、聊天记录或现场图片，请一并附上。涉及个人隐私处务必打码，保留关键信息即可。",
  },
  {
    step: "06",
    icon: "ri-chat-smile-3-line",
    title: "个人观点",
    desc: "可在末尾简短说明你的立场或补充细节，但请与事实区分开，明确标注「我的判断」以免混淆视听。",
  },
];

export default function Format() {
  return (
    <section id="format" className="scroll-mt-20 bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-sm font-medium text-accent-800">
              <i className="ri-file-list-3-line"></i> 吃瓜投稿格式规范
            </span>
            <h2 className="mt-4 font-display text-3xl text-foreground-900 md:text-4xl">
              一份合格瓜料的六段式
            </h2>
            <p className="mt-3 text-foreground-700">
              按下面这个标准结构投稿，审核一眼就能看懂你在说什么，过审自然更快。格式越规范，瓜料越稳。
            </p>
          </div>
          <a
            href="#submit"
            onClick={(e) => {
              e.preventDefault();
              const el = document.getElementById("submit");
              if (el) el.scrollIntoView({ behavior: "smooth" });
            }}
            className="inline-flex shrink-0 items-center gap-2 self-start whitespace-nowrap rounded-full border border-accent-300 bg-accent-50 px-5 py-2.5 text-sm font-medium text-accent-700 transition-colors hover:bg-accent-100 lg:self-auto"
          >
            按此格式投稿 <i className="ri-arrow-right-up-line"></i>
          </a>
        </div>

        <div className="mt-10 grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {FORMAT_STEPS.map((item) => (
            <article
              key={item.step}
              className="group rounded-2xl border border-background-200 bg-background-100/50 p-6 transition-colors hover:border-accent-200 hover:bg-accent-50/60"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-accent-500 text-xl text-background-50">
                  <i className={item.icon}></i>
                </span>
                <span className="font-display text-3xl text-accent-200">{item.step}</span>
              </div>
              <h3 className="mt-4 text-lg font-bold text-foreground-900">{item.title}</h3>
              <p className="mt-2 text-sm leading-6 text-foreground-700">{item.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}